import { InquiryStatusEnum } from 'anchor-kyb-service/types';
import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { usePersonaKYBStatus } from '~/hooks/reactQuery/queries/usePersonaKYBStatus';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
const personaInquiryLoader = 'persona-inquiry';
export const taxUpdateReviewToastTestId = 'tax-update-review-toast';
export const taxUpdateErrorToastTestId = 'tax-update-error-toast';
export function useStartTaxUpdate() {
    const { personaClient } = useIoContext();
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { startLoader, stopLoader, showErrorToast, showInfoToast } = useOverlayContext();
    const isVendor = useStore(selectors.user.isVendor);
    const { refresh: refreshPersonaKYBStatus } = usePersonaKYBStatus({
        enabled: isVendor
    });
    async function startTaxUpdate(businessId) {
        startLoader(personaInquiryLoader);
        const result = await handlePromise(api.vendor.getTaxUpdateInquiry(businessId));
        if (result.success) {
            const { inquiryId, sessionToken, inquiryStatus } = result.data;
            if (InquiryStatusEnum.NeedsReview === inquiryStatus) {
                await refreshPersonaKYBStatus({
                    throwOnError: false
                });
                stopLoader(personaInquiryLoader);
                showInfoToast(commonTexts.toasts.taxUpdateSubmittedForReview(), taxUpdateReviewToastTestId);
                return;
            }
            const client = personaClient({
                onError: ()=>stopLoader(personaInquiryLoader),
                onReady: ()=>stopLoader(personaInquiryLoader),
                onComplete: ()=>{
                    refreshPersonaKYBStatus({
                        throwOnError: false
                    });
                    showInfoToast(commonTexts.toasts.taxUpdateSubmittedForReview(), taxUpdateReviewToastTestId);
                }
            });
            client.open(inquiryId, sessionToken);
        } else {
            showErrorToast(commonTexts.toasts.failedToStartKybProcess(), taxUpdateErrorToastTestId);
            stopLoader(personaInquiryLoader);
        }
    }
    return {
        startTaxUpdate
    };
}
